export default __webpack_public_path__ + "static/media/crista.c32b6603.jpeg";